import { render, staticRenderFns } from "./ServicesLayout.vue?vue&type=template&id=ca7cb704&"
import script from "./ServicesLayout.vue?vue&type=script&lang=js&"
export * from "./ServicesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports